import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, COLLECTION } from '@/plugins/sdk/fields'
import Model from '@/plugins/sdk/resources/Asset/Manufacturer/Model'

export default class extends Resource {
  static name = 'asset_type'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      description: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      models: new COLLECTION(Model)
    }
  }
}
